import { render, staticRenderFns } from "./text.vue?vue&type=template&id=a04b24f0&scoped=true&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04b24f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04b24f0')) {
      api.createRecord('a04b24f0', component.options)
    } else {
      api.reload('a04b24f0', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=a04b24f0&scoped=true&", function () {
      api.rerender('a04b24f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/text.vue"
export default component.exports